import { ColourTheme } from "@components/atoms/ColourTheme"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Highlighted Mega",
  tags: ["#page"],
}

export default defineBlock("section/highlighted-mega", (props) => {
  return (
    <Appear className={cn("highlighted-mega w-maxContentW mx-auto my-9 md:px-6")}>
      <ColourTheme
        theme={props.colourTheme || props.defaultColourTheme}
        className="w-full pt-9 pb-6 rounded-lg [&_.section-bridge-description]:text-current [&_.features-stack-inner-card]:!border-current [&_.features-stack-inner-card]:!border-opacity-20 [&_.features-stack-inner-card_p]:!text-current [&_.features-stack-inner-card_p>strong]:!text-current [&_.benefits-stack-inner-card]:bg-current [&_.benefits-stack-inner-card]:bg-opacity-10 [&_.benefits-stack-inner-card_p]:!text-current [&_.benefits-stack-inner-card_p>strong]:!text-current [&_.button-cta-inner]:bg-[rgb(var(--theme-color)/0.1)] [&_.button-cta-inner]:!text-current"
      >
        <div className="w-full max-w-blogPostVideoW block-padding mx-auto [&_.section-bridge]:mt-0 [&_.section-bridge]:mb-6 [&_.features-stack-inner]:my-6 [&_.benefits-stack-inner]:my-6">
          <InnerBlocks
            allowedBlocks={[
              "section/section-bridge",
              "content/inline-media",
              "section/features-stack-inner",
              "content/inline-buttons",
              "section/benefits-stack-inner",
              "core/table",
              "content/button-cta",
            ]}
            template={[
              ["section/section-bridge", {}],
              ["content/inline-media", {}],
              ["section/features-stack-inner", {}],
              ["content/inline-buttons", {}],
              ["section/benefits-stack-inner", {}],
              ["core/table", {}],
              ["content/button-cta", {}],
              ["content/inline-buttons", {}],
            ]}
          />
        </div>
      </ColourTheme>
    </Appear>
  )
})
